export type ResolveValueErrorType = {
  __resolveValueError__: string;
};

export function isResolveValueError(
  data: unknown,
): data is ResolveValueErrorType {
  return (
    data !== undefined &&
    data !== null &&
    typeof data === 'object' &&
    (data as ResolveValueErrorType).__resolveValueError__ !== undefined
  );
}
